import React, {Component} from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ShareIcon from '@material-ui/icons/Share';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import { DateUtils } from "react-day-picker";
import { getUsageInfo, getUsersList, shareUsageInfo } from '../../../../api';
import DatePicker from './DatePicker';
import SelectReportType from './SelectReportType';
import ShareReportResponse from './ShareReportResponse';

const moment = extendMoment(originalMoment);
const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    margin: "20px"
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
});

function compareNames( user1, user2 ) {
  if ( user1.username < user2.username ){
    return -1;
  }
  if ( user1.username > user2.username ){
    return 1;
  }
  return 0;
}

function GenerateUsersList(props){
  const { user, users, setUser, classes} = props;
  return (
    <FormControl className={classes.formControl}>
      <InputLabel shrink htmlFor="user-label-placeholder">
        User
      </InputLabel>
      <Select
        value={user}
        onChange={(event) => {setUser(event)}}
        input={<Input name="user" id="user-label-placeholder" />}
        displayEmpty
        name="user"
      >
        <MenuItem value={null}>
          All
        </MenuItem>
        {
          users.map((currentUser) =>
          <MenuItem value={currentUser.username} key={currentUser.username}>{currentUser.username}</MenuItem>
        )
        }
      </Select>
    </FormControl>
  )
}

class OptionsPicker extends Component{
  constructor(props){
    super(props);
    this.state = {
      user: null,
      users: [],
      openSelectReportType: false,
      shareReportResponse: null,
      from: new Date(),
      to: new Date()
    }
  }

  componentDidMount(){
    const { isSuperuser, onRef } = this.props;
    onRef(this);
    if (isSuperuser){
      getUsersList(this.onGetUsersListSuccess, this.onGetUsersListError);
    }
  }

  componentWillUnmount() {
    const { onRef } = this.props;
    onRef(undefined);
  }

  UNSAFE_componentWillReceiveProps(nextProps){
     const {is_plugin} = nextProps;
     if (is_plugin !== this.props.is_plugin) {
        const {user} = this.state;
        this.getInfo(user, undefined, is_plugin);
     }
  }

  onGetUsersListSuccess = response => {
    if(!response.error){
      const { users } = response;
      users.sort(compareNames);

      this.setState({users});
    }else{
      this.setState({users: []});
    }
  }

  onGetUsersListError = () => {
    this.setState({users: []});
  }

  closeSelectReportType = () => {
    this.setState({openSelectReportType: false});
  }

  onShareReportsSuccess = (response) => {
    this.setState({shareReportResponse: response.error? 'error': 'success'});
  }

  onShareReportsError = () => {
    this.setState({shareReportResponse: 'error'});
  }

  closeShareReportResponse = () => {
    this.setState({shareReportResponse: null});
  }

  getReportType = (type) => {
    this.closeSelectReportType();
    const { from, to, user } = this.state;
    if(from !== undefined && to !== undefined){
      const start = from.toLocaleDateString();
      const end = to.toLocaleDateString();
      let params = `start=${start}&end=${end}&type=${type}`;
      const { isSuperuser, is_plugin } = this.props;
      if (is_plugin !== null){
        params += `&is_plugin=${is_plugin}`
      }
      if(isSuperuser && user){
        params += `&user=${user}`;
      }
      shareUsageInfo(params, this.onShareReportsSuccess, this.onShareReportsError);
    }
  }

  getUserReport = (user) => {
    this.setState({user});   
    this.getInfo(user, undefined, this.props.is_plugin);
  }

  getInfo = (user, range, is_plugin) => {
    const { onUsageGetSuccess, onUsageGetError } = this.props; 
    const { from, to } = range === undefined? this.state: range;
    if(from !== undefined && to !== undefined){
      const { isSuperuser } = this.props;
      const { from, to } = range === undefined? this.state: range;
      const start = from.toLocaleDateString();
      const end = to.toLocaleDateString();
      let params = `start=${start}&end=${end}`;
      if (is_plugin !== null){
        params += `&is_plugin=${is_plugin}`
      }
      if(isSuperuser && user){
        params += `&user=${user}`;
      }
      getUsageInfo(params, onUsageGetSuccess, onUsageGetError);
    }
  }

  getReports = () => {
    this.setState({reports: []});
    const { user } = this.state;
    this.getInfo(user, undefined, this.props.is_plugin);
  }

  shareReports = () => {
    this.setState({openSelectReportType: true});
  }

  handleDayClick = (day) => {
    const { from, to, user } = this.state;
    let range = null;
    if(from!==undefined && to!== undefined){
      range = DateUtils.addDayToRange(day, {from: undefined, to: undefined});
      
    }else{
      range = DateUtils.addDayToRange(day, this.state);
    }   
    this.setState(range);
    this.getInfo(user, range, this.props.is_plugin)
  }

  handleListItemClick = (index, selectedIndex) => {   
    const today = moment();
    let range = {};
    switch (index) {
      case 0:
        if(selectedIndex !== 0){
          range = {
            from: undefined,
            to: undefined
          };
        }
        break;
      case 1:
        range = {
          from: today.clone().startOf('day').toDate(), 
          to: today.clone().startOf('day').toDate()
        };
        break;
      case 2:
        range = {
          from: today.clone().subtract(1, "days").startOf('day').toDate(),
          to: today.clone().subtract(1, "days").startOf('day').toDate()
        };
        break;
      case 3:
        range = {
          from: moment().subtract(1, "months").startOf("month").toDate(),
          to: moment().subtract(1, "months").endOf("month").toDate()
        };
        break;
      case 4:
        range = {
          from: today.clone().subtract(6, "days").startOf('day').toDate(), 
          to: today.clone().toDate()
        };
        break;
      case 5:
        range = {
          from: today.clone().subtract(29, "days").startOf('day').toDate(), 
          to: today.clone().toDate()
        };
        break;
      case 6:
        range = {
          from: today.clone().subtract(89, "days").startOf('day').toDate(), 
          to: today.clone().toDate()
        };
        break;
      default:
        range = {
          from: undefined,
          to: undefined
        };
        break;
    }
    this.setState(range);
    const { user } = this.state;
    this.getInfo(user, range, this.props.is_plugin);
  };

  setUser = (event) => {
    this.setState({user: event.target.value});
    this.getInfo(event.target.value, undefined, this.props.is_plugin);
  }

  render(){
    const { classes, isSuperuser } = this.props;
    const { user, users, openSelectReportType, shareReportResponse, from, to } = this.state;
    const modifiers = { start: from, end: to };
    
    return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DatePicker from={from}
                        to={to}
                        modifiers={modifiers}
                        handleDayClick={this.handleDayClick}
                        handleListItemClick={this.handleListItemClick} />
          </Grid>
          {isSuperuser &&
            <Grid item xs={12}>
              <GenerateUsersList user={user} 
                                 users={users} 
                                 setUser={this.setUser}
                                 classes={classes}
                                 />
            </Grid>
           }
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button variant="contained" onClick={this.shareReports} color="primary" fullWidth>
                Share
                <ShareIcon className={classes.rightIcon} />
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button variant="contained" onClick={this.getReports} color="primary"  fullWidth>
                Report
                <ShowChartIcon className={classes.rightIcon} />
              </Button>
            </Grid>
          </Grid>
        </Grid>
          <Grid item xs={12}>
            <SelectReportType setClose={this.closeSelectReportType}
                            setSelectedValue={this.getReportType}
                            open={openSelectReportType}/>       
            <ShareReportResponse response={shareReportResponse}
                                close={this.closeShareReportResponse} />
          </Grid>
        </Grid>
    );
  }
}

export default withStyles(styles)(OptionsPicker);
